import { useContext } from 'react'

import { MedicalRecordFormContext, MedicalRecordFormData } from '../contexts/MedicalRecordFormContext'

export function useMedicalRecordForm(): MedicalRecordFormData {
  return useContext(MedicalRecordFormContext)
}